// src/api/vehicleApi.ts
import axios from 'axios';
import { Vehicle } from '../state/types';
import { fetchAuthSession } from 'aws-amplify/auth';

export const getVehiclesFromDb = async (
  body: Record<string, any>
): Promise<{ vehicles: Vehicle[]; total: number }> => {
  try {
    if (body.clientId === 'undefined') return { vehicles: [], total: 0 }
    const awsTokens = await fetchAuthSession()
    const authHeader = 'bwdevenv' //awsTokens.tokens?.idToken?.toString()
    const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/asset/client`;
    const headers = {
      Authorization: authHeader,
    };

    const response = await axios.post<{ vehicles: Vehicle[]; total_vehicles: number }>(url, body, { headers });

    const vehicles = response.data.vehicles.map((vehicle: any) => {
      const bgrImage = vehicle.imageBgrExterior?.find(
        (img: any) => img.imageOriginalName?.endsWith('01.jpg')
      )?.imageUrlCf;
      const regularImage = vehicle.imageExterior?.[0]?.imageUrlCf;
      const cfUrl = bgrImage || regularImage || '';
      const thumbnailUrl = cfUrl
        ? cfUrl.replace(/(\.[^./\?]+)$/, '_thumbnail$1')
        : '';
      const assetId = vehicle.pk.split('#')[1];
      const rawClientId = vehicle.clientIdentifier;
      const cleanedClientId = /U\d{2}$/.test(rawClientId)
        ? rawClientId.slice(0, -3)
        : rawClientId;

      return {
        ...vehicle,
        vin: vehicle.assetIdentifier,
        clientId: cleanedClientId,
        created_at: vehicle.sk,
        thumbnail: thumbnailUrl,
        config: vehicle.configurationName,
        assetId,
      };
    });

    return {
      vehicles,
      total: response.data.total_vehicles,
    };
  } catch (error) {
    console.error('Error fetching vehicles:', error);
    return { vehicles: [], total: 0 };
  }
};

